"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Icon_1 = __importDefault(require("@mui/material/Icon"));
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var material_1 = require("@mui/material");
function Login(_a) {
    var userManager = _a.userManager;
    var _b = react_1.default.useState(null), processLogin = _b[0], setProcessLogin = _b[1];
    var _c = react_1.default.useState(null), error = _c[0], setError = _c[1];
    var _d = react_1.default.useState(null), email = _d[0], setEmail = _d[1];
    function doLogin(e) {
        e.preventDefault();
        if (email && userManager) {
            setProcessLogin(true);
            userManager.login(email).then(function (result) {
                if (result === false) {
                    setError('Invalid email address. Please use the same email address you use with Condo Control Central.');
                }
            });
        }
    }
    var loginFrom = (react_1.default.createElement("form", { noValidate: true, autoComplete: "off", onSubmit: function (e) { return doLogin(e); } },
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 5 },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement("h4", { className: "center" }, "Login")),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(TextField_1.default, { id: "email", label: "Email address used with Condo Control Central", value: email || '', onChange: function (event) { return setEmail(event.target.value); }, sx: {
                        width: '100%',
                    } })),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12, className: "center" },
                react_1.default.createElement(Button_1.default, { variant: "contained", sx: {
                        backgroundColor: '#f37f30',
                        color: 'white',
                        marginBottom: '20px',
                    }, endIcon: react_1.default.createElement(Icon_1.default, null, "mail"), type: "submit" }, "Send Login Link")))));
    var loggingIn = (react_1.default.createElement(Grid_1.default, { container: true, spacing: 5 },
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
            react_1.default.createElement("h4", { className: "center" },
                error && (react_1.default.createElement(react_1.default.Fragment, null, "Error")),
                !error && (react_1.default.createElement(react_1.default.Fragment, null, "Check your Email")))),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, className: "center" },
            error && (react_1.default.createElement(material_1.Alert, { severity: "error" },
                react_1.default.createElement(material_1.AlertTitle, null, "Error"),
                error)),
            react_1.default.createElement("p", null, "If your email address matches one in our system you will receive a login link. Please check your email to continue."))));
    var loginDisplay;
    if (processLogin) {
        loginDisplay = loggingIn;
    }
    else {
        loginDisplay = loginFrom;
    }
    return (react_1.default.createElement("div", null, loginDisplay));
}
exports.default = Login;
